import {
  fetchTutorials,
  getEvent,
  getEvents,
  getEventTags,
  getPopularItems,
  getProducts,
  getProductStages,
  getProductTypes,
  getSymptoms,
  getSymptomsCategories,
  getTheBasics,
  getTopicDetails,
  getTopics,
  getTutorialBySlug,
  getTutorialSubcategories,
  getTopicDetailById,
  fetchArticlesByTopic,
  getRelatedTutorials,
  getSymptomDetailById,
  getProductBySlug,
  getWellnessPrograms,
  getWellnessProgramById,
} from '../util/api';
import { getDefaultLocale, getStrapiLocale, isArrayLength } from '../util/genericHelpers';
import { PROGRAM_STATUS, getStaticWellnessSelfCheck } from '../util/enums';
import staticCardImage from '../assets/wellness-program/wellness-img1.png';

const defaultLocale = getStrapiLocale() || 'el-GR';
export const FETCH_TUTORIALS_REQUEST = 'app/strapi/FETCH_TUTORIALS_REQUEST';
export const FETCH_TUTORIALS_SUCCESS = 'app/strapi/FETCH_TUTORIALS_SUCCESS';
export const FETCH_TUTORIALS_ERROR = 'app/strapi/FETCH_TUTORIALS_ERROR';
export const CLEAR_TUTORIALS = 'app/strapi/CLEAR_TUTORIALS';
export const FETCH_EVENTS_REQUEST = 'app/strapi/FETCH_EVENTS_REQUEST';
export const FETCH_EVENTS_SUCCESS = 'app/strapi/FETCH_EVENTS_SUCCESS';
// Single Event Detail
export const FETCH_EVENT_REQUEST = 'app/strapi/FETCH_EVENT_REQUEST';
export const FETCH_EVENT_SUCCESS = 'app/strapi/FETCH_EVENT_SUCCESS';
export const FETCH_EVENT_ERROR = 'app/strapi/FETCH_EVENT_ERROR';
export const FETCH_TOPIC_REQUEST = 'app/strapi/FETCH_TOPIC_REQUEST';
export const FETCH_TOPIC_SUCCESS = 'app/strapi/FETCH_TOPIC_SUCCESS';
export const FETCH_TOPIC_DETAILS_REQUEST = 'app/strapi/FETCH_TOPIC_DETAILS_REQUEST';
export const FETCH_TOPIC_DETAILS_SUCCESS = 'app/strapi/FETCH_TOPIC_DETAILS_SUCCESS';
export const FETCH_TUTORIALS_SUBCATEGORIES_REQUEST =
  'app/strapi/FETCH_TUTORIALS_SUBCATEGORIES_REQUEST';
export const FETCH_TUTORIALS_SUBCATEGORIES_SUCCESS =
  'app/strapi/FETCH_TUTORIALS_SUBCATEGORIES_SUCCESS';
export const FETCH_SYMPTOMS_SUCCESS = 'app/strapi/FETCH_SYMPTOMS_SUCCESS';
export const FETCH_THE_BASICS_REQUEST = 'app/strapi/FETCH_THE_BASICS_REQUEST';
export const FETCH_THE_BASICS_SUCCESS = 'app/strapi/FETCH_THE_BASICS_SUCCESS';
export const FETCH_THE_BASICS_ERROR = 'app/strapi/FETCH_THE_BASICS_ERROR';
export const FETCH_SYMPTOM_BY_SLUG_REQUEST = 'app/strapi/FETCH_SYMPTOM_BY_SLUG_REQUEST';
export const FETCH_SYMPTOM_BY_SLUG_SUCCESS = 'app/strapi/FETCH_SYMPTOM_BY_SLUG_SUCCESS';
export const FETCH_SYMPTOM_BY_SLUG_ERROR = 'app/strapi/FETCH_SYMPTOM_BY_SLUG_ERROR';
export const FETCH_SYMPTOM_CATEGORIES_REQUEST = 'app/strapi/FETCH_SYMPTOM_CATEGORIES_REQUEST';
export const FETCH_SYMPTOM_CATEGORIES_SUCCESS = 'app/strapi/FETCH_SYMPTOM_CATEGORIES_SUCCESS';
export const FETCH_SYMPTOM_CATEGORIES_ERROR = 'app/strapi/FETCH_SYMPTOM_CATEGORIES_ERROR';
export const FETCH_EVENT_TAGS_REQUEST = 'app/strapi/FETCH_EVENT_TAGS_REQUEST';
export const FETCH_EVENT_TAGS_SUCCESS = 'app/strapi/FETCH_EVENT_TAGS_SUCCESS';
export const FETCH_EVENT_TAGS_ERROR = 'app/strapi/FETCH_EVENT_TAGS_ERROR';
export const FETCH_POPULAR_REQUEST = 'app/strapi/FETCH_POPULAR_REQUEST';
export const FETCH_POPULAR_SUCCESS = 'app/strapi/FETCH_POPULAR_SUCCESS';
export const FETCH_POPULAR_ERROR = 'app/strapi/FETCH_POPULAR_ERROR';
export const FETCH_PRODUCTS_REQUEST = 'app/strapi/FETCH_PRODUCTS_REQUEST';
export const FETCH_PRODUCTS_SUCCESS = 'app/strapi/FETCH_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_ERROR = 'app/strapi/FETCH_PRODUCTS_ERROR';
export const FETCH_PRODUCT_STAGES_REQUEST = 'app/strapi/FETCH_PRODUCT_STAGES_REQUEST';
export const FETCH_PRODUCT_STAGES_SUCCESS = 'app/strapi/FETCH_PRODUCT_STAGES_SUCCESS';
export const FETCH_PRODUCT_STAGES_ERROR = 'app/strapi/FETCH_PRODUCT_STAGES_ERROR';
export const FETCH_PRODUCT_TYPES_REQUEST = 'app/strapi/FETCH_PRODUCT_TYPES_REQUEST';
export const FETCH_PRODUCT_TYPES_SUCCESS = 'app/strapi/FETCH_PRODUCT_TYPES_SUCCESS';
export const FETCH_PRODUCT_TYPES_ERROR = 'app/strapi/FETCH_PRODUCT_TYPES_ERROR';
export const FETCH_TUTORIAL_DETAIL_REQUEST = 'app/strapi/FETCH_TUTORIAL_DETAIL_REQUEST';
export const FETCH_TUTORIAL_DETAIL_SUCCESS = 'app/strapi/FETCH_TUTORIAL_DETAIL_SUCCESS';
export const FETCH_TUTORIAL_DETAIL_ERROR = 'app/strapi/FETCH_TUTORIAL_DETAIL_ERROR';
export const FETCH_WRITTEN_GUIDE_BY_ID_REQUEST = 'app/strapi/FETCH_WRITTEN_GUIDE_BY_ID_REQUEST';
export const FETCH_WRITTEN_GUIDE_BY_ID_SUCCESS = 'app/strapi/FETCH_WRITTEN_GUIDE_BY_ID_SUCCESS';
export const FETCH_WRITTEN_GUIDE_BY_ID_ERROR = 'app/strapi/FETCH_WRITTEN_GUIDE_BY_ID_ERROR';
export const FETCH_RELEVANT_GUIDES_REQUEST = 'app/strapi/FETCH_RELEVANT_GUIDES_REQUEST';
export const FETCH_RELEVANT_GUIDES_SUCCESS = 'app/strapi/FETCH_RELEVANT_GUIDES_SUCCESS';
export const FETCH_RELEVANT_GUIDES_ERROR = 'app/strapi/FETCH_RELEVANT_GUIDES_ERROR';
export const FETCH_SYMPTOM_DETAIL_BY_ID_REQUEST = 'app/strapi/FETCH_SYMPTOM_DETAIL_BY_ID_REQUEST';
export const FETCH_SYMPTOM_DETAIL_BY_ID_SUCCESS = 'app/strapi/FETCH_SYMPTOM_DETAIL_BY_ID_SUCCESS';
export const FETCH_SYMPTOM_DETAIL_BY_ID_ERROR = 'app/strapi/FETCH_SYMPTOM_DETAIL_BY_ID_ERROR';
export const FETCH_RELATED_TUTORIALS_REQUEST = 'app/strapi/FETCH_RELATED_TUTORIALS_REQUEST';
export const FETCH_RELATED_TUTORIALS_SUCCESS = 'app/strapi/FETCH_RELATED_TUTORIALS_SUCCESS';
export const FETCH_RELATED_TUTORIALS_ERROR = 'app/strapi/FETCH_RELATED_TUTORIALS_ERROR';
export const FETCH_PRODUCT_BY_SLUG_REQUEST = 'app/strapi/FETCH_PRODUCT_BY_SLUG_REQUEST';
export const FETCH_PRODUCT_BY_SLUG_SUCCESS = 'app/strapi/FETCH_PRODUCT_BY_SLUG_SUCCESS';
export const FETCH_PRODUCT_BY_SLUG_ERROR = 'app/strapi/FETCH_PRODUCT_BY_SLUG_ERROR';
export const FETCH_WELLNESS_PROGRAMS_REQUEST = 'app/strapi/FETCH_WELLNESS_PROGRAMS_REQUEST';
export const FETCH_WELLNESS_PROGRAMS_SUCCESS = 'app/strapi/FETCH_WELLNESS_PROGRAMS_SUCCESS';
export const FETCH_WELLNESS_PROGRAMS_ERROR = 'app/strapi/FETCH_WELLNESS_PROGRAMS_ERROR';
export const FETCH_WELLNESS_PROGRAM_BY_ID_REQUEST =
  'app/strapi/FETCH_WELLNESS_PROGRAM_BY_ID_REQUEST';
export const FETCH_WELLNESS_PROGRAM_BY_ID_SUCCESS =
  'app/strapi/FETCH_WELLNESS_PROGRAM_BY_ID_SUCCESS';
export const FETCH_WELLNESS_PROGRAM_BY_ID_ERROR = 'app/strapi/FETCH_WELLNESS_PROGRAM_BY_ID_ERROR';

// ================ Reducer ================ //
const initialState = {
  fetchTutorialsInProgress: false,
  tutorials: [],
  module: [],
  fetchTutorialsError: false,
  event: null,
  fetchEventInProgress: false,
  fetchEventError: false,
  events: [],
  writtenGuides: [],
  fetchEventsInProgress: false,
  topics: [],
  basicTopics: [],
  topicDetails: [],
  product: null,
  fetchProductBySlugInProgress: false,
  fetchProductBySlugError: false,
  fetchTopicDetailsInProgress: false,
  fetchTutorialsSubcategoriesInProgress: false,
  tutorialsSubcategories: [],
  symptoms: [],
  fetchTopicsInProgress: false,
  fetchTopicsError: null,
  fetchSymptomInProgress: false,
  fetchSymptomError: null,
  symptomCategories: [],
  fetchSymptomCategoriesInProgress: false,
  fetchSymptomCategoriesError: null,
  fetchPopularInProgress: false,
  popularTutorials: [],
  popularTopics: [],
  fetchPopularError: null,
  products: [],
  productStages: [],
  productTypes: [],
  fetchProductsInProgress: false,
  fetchProductsError: false,
  fetchProductStagesInProgress: false,
  fetchProductStagesError: false,
  fetchProductTypesInProgress: false,
  fetchProductTypesError: false,
  tutorialDetail: null,
  fetchTutorialDetailInProgress: false,
  fetchTutorialDetailError: false,
  writtenGuideDetail: null,
  fetchWrittenGuideDetailInProgress: false,
  fetchWrittenGuideDetailError: false,
  relevantGuides: [],
  relatedTutorials: [],
  fetchRelatedTutorialsInProgress: false,
  fetchRelatedTutorialsError: false,
  symptomDetail: null,
  fetchSymptomDetailByIdInProgress: false,
  fetchSymptomDetailByIdError: false,
  wellnessPrograms: [],
  fetchWellnessProgramsInProgress: false,
  fetchWellnessProgramsError: false,
  wellnessProgram: null,
  fetchWellnessProgramByIdInProgress: false,
  fetchWellnessProgramByIdError: false,
};
export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_TUTORIAL_DETAIL_REQUEST:
      return {
        ...state,
        fetchTutorialDetailInProgress: true,
        fetchTutorialDetailError: false,
      };
    case FETCH_TUTORIAL_DETAIL_SUCCESS:
      return {
        ...state,
        tutorialDetail: payload,
        fetchTutorialDetailInProgress: false,
      };
    case FETCH_TUTORIAL_DETAIL_ERROR:
      return {
        ...state,
        fetchTutorialDetailInProgress: false,
        fetchTutorialDetailError: true,
      };
    case FETCH_SYMPTOM_BY_SLUG_REQUEST:
      return {
        ...state,
        fetchSymptomInProgress: true,
      };
    case FETCH_SYMPTOM_BY_SLUG_SUCCESS:
      return {
        ...state,
        symptoms: payload,
        fetchSymptomInProgress: false,
      };
    case FETCH_SYMPTOM_BY_SLUG_ERROR:
      return {
        ...state,
        fetchSymptomInProgress: false,
        fetchSymptomError: true,
      };
    case FETCH_PRODUCTS_REQUEST:
      return {
        ...state,
        fetchProductsInProgress: true,
        fetchProductsError: false,
      };
    case FETCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: payload,
        fetchProductsInProgress: false,
      };
    case FETCH_PRODUCTS_ERROR:
      return {
        ...state,
        fetchProductsInProgress: false,
        fetchProductsError: true,
      };
    case FETCH_PRODUCT_STAGES_REQUEST:
      return {
        ...state,
        fetchProductStagesInProgress: true,
        fetchProductStagesError: false,
      };
    case FETCH_PRODUCT_STAGES_SUCCESS:
      return {
        ...state,
        productStages: payload,
        fetchProductStagesInProgress: false,
      };
    case FETCH_PRODUCT_STAGES_ERROR:
      return {
        ...state,
        fetchProductStagesInProgress: false,
        fetchProductStagesError: true,
      };
    case FETCH_PRODUCT_TYPES_REQUEST:
      return {
        ...state,
        fetchProductTypesInProgress: true,
        fetchProductTypesError: false,
      };
    case FETCH_PRODUCT_TYPES_SUCCESS:
      return {
        ...state,
        productTypes: payload,
        fetchProductTypesInProgress: false,
      };
    case FETCH_PRODUCT_TYPES_ERROR:
      return {
        ...state,
        fetchProductTypesInProgress: false,
        fetchProductTypesError: true,
      };
    case FETCH_PRODUCT_BY_SLUG_REQUEST:
      return {
        ...state,
        fetchProductBySlugInProgress: true,
        fetchProductBySlugError: false,
      };
    case FETCH_PRODUCT_BY_SLUG_SUCCESS:
      return {
        ...state,
        product: payload,
        fetchProductBySlugInProgress: false,
      };
    case FETCH_PRODUCT_BY_SLUG_ERROR:
      return {
        ...state,
        fetchProductBySlugInProgress: false,
        fetchProductBySlugError: true,
      };
    case FETCH_THE_BASICS_REQUEST:
      return {
        ...state,
        fetchTopicsInProgress: true,
      };
    case FETCH_THE_BASICS_SUCCESS:
      return {
        ...state,
        basicTopics: payload,
        fetchTopicsInProgress: false,
      };
    case FETCH_THE_BASICS_ERROR:
      return {
        ...state,
        fetchTopicsInProgress: false,
        fetchTopicsError: true,
      };
    case FETCH_SYMPTOMS_SUCCESS:
      return {
        ...state,
        symptoms: payload,
      };
    case FETCH_POPULAR_REQUEST:
      return {
        ...state,
        fetchPopularInProgress: true,
        fetchPopularError: null,
      };
    case FETCH_POPULAR_SUCCESS:
      return {
        ...state,
        fetchPopularInProgress: false,
        popularTutorials: payload?.tutorials || [],
        popularTopics: payload?.topics || [],
      };
    case FETCH_POPULAR_ERROR:
      return {
        ...state,
        fetchPopularInProgress: false,
        fetchPopularError: true,
      };
    case FETCH_TUTORIALS_SUBCATEGORIES_REQUEST:
      return {
        ...state,
        fetchTutorialsSubcategoriesInProgress: true,
      };
    case FETCH_TUTORIALS_SUBCATEGORIES_SUCCESS:
      return {
        ...state,
        tutorialsSubcategories: payload,
        fetchTutorialsSubcategoriesInProgress: false,
      };
    case FETCH_TOPIC_REQUEST:
      return {
        ...state,
        fetchWrittenGuidesInProgress: true,
      };
    case FETCH_TOPIC_SUCCESS:
      return {
        ...state,
        writtenGuides: payload,
        fetchWrittenGuidesInProgress: false,
      };
    case FETCH_TOPIC_DETAILS_REQUEST:
      return {
        ...state,
        fetchTopicDetailsInProgress: true,
      };
    case FETCH_TOPIC_DETAILS_SUCCESS:
      return {
        ...state,
        topicDetails: payload,
        fetchTopicDetailsInProgress: false,
      };
    case FETCH_EVENT_REQUEST:
      return {
        ...state,
        event: null,
        fetchEventInProgress: true,
        fetchEventError: false,
      };
    case FETCH_EVENT_SUCCESS:
      return {
        ...state,
        event: payload,
        fetchEventInProgress: false,
      };
    case FETCH_EVENT_ERROR:
      return {
        ...state,
        event: null,
        fetchEventInProgress: false,
        fetchEventError: true,
      };
    case FETCH_EVENTS_REQUEST:
      return {
        ...state,
        fetchEventsInProgress: true,
      };
    case FETCH_EVENTS_SUCCESS:
      return {
        ...state,
        fetchEventsInProgress: false,
        events: payload,
      };
    case FETCH_TUTORIALS_REQUEST:
      return {
        ...state,
        fetchTutorialsInProgress: true,
      };
    case FETCH_TUTORIALS_SUCCESS:
      return {
        ...state,
        fetchTutorialsInProgress: false,
        tutorials: payload?.tutorials,
        module: payload?.module,
      };
    case FETCH_TUTORIALS_ERROR:
      return {
        ...state,
        fetchTutorialsInProgress: false,
        fetchTutorialsError: true,
      };
    case CLEAR_TUTORIALS:
      return {
        ...state,
        tutorials: [],
      };
    case FETCH_SYMPTOM_CATEGORIES_REQUEST:
      return {
        ...state,
        fetchSymptomCategoriesInProgress: true,
        fetchSymptomCategoriesError: false,
      };
    case FETCH_SYMPTOM_CATEGORIES_SUCCESS:
      return {
        ...state,
        symptomCategories: payload,
        fetchSymptomCategoriesInProgress: false,
      };
    case FETCH_SYMPTOM_CATEGORIES_ERROR:
      return {
        ...state,
        fetchSymptomCategoriesInProgress: false,
        fetchSymptomCategoriesError: true,
      };
    case FETCH_EVENT_TAGS_REQUEST:
      return {
        ...state,
        fetchEventTagsInProgress: true,
        fetchEventTagsError: false,
      };
    case FETCH_EVENT_TAGS_SUCCESS:
      return {
        ...state,
        eventTags: payload,
        fetchEventTagsInProgress: false,
      };
    case FETCH_EVENT_TAGS_ERROR:
      return {
        ...state,
        fetchEventTagsInProgress: false,
        fetchEventTagsError: true,
      };
    case FETCH_WRITTEN_GUIDE_BY_ID_REQUEST:
      return {
        ...state,
        fetchWrittenGuideDetailInProgress: true,
        fetchWrittenGuideDetailError: false,
      };
    case FETCH_WRITTEN_GUIDE_BY_ID_SUCCESS:
      return {
        ...state,
        writtenGuideDetail: payload,
        fetchWrittenGuideDetailInProgress: false,
      };
    case FETCH_WRITTEN_GUIDE_BY_ID_ERROR:
      return {
        ...state,
        fetchWrittenGuideDetailInProgress: false,
        fetchWrittenGuideDetailError: true,
      };
    case FETCH_RELEVANT_GUIDES_REQUEST:
      return {
        ...state,
        fetchRelevantGuidesInProgress: true,
        fetchRelevantGuidesError: false,
      };
    case FETCH_RELEVANT_GUIDES_SUCCESS:
      return {
        ...state,
        relevantGuides: payload,
        fetchRelevantGuidesInProgress: false,
      };
    case FETCH_RELEVANT_GUIDES_ERROR:
      return {
        ...state,
        fetchRelevantGuidesInProgress: false,
        fetchRelevantGuidesError: true,
      };
    case FETCH_SYMPTOM_DETAIL_BY_ID_REQUEST:
      return {
        ...state,
        fetchSymptomDetailByIdInProgress: true,
        fetchSymptomDetailByIdError: false,
      };
    case FETCH_SYMPTOM_DETAIL_BY_ID_SUCCESS:
      return {
        ...state,
        symptomDetail: payload,
        fetchSymptomDetailByIdInProgress: false,
      };
    case FETCH_SYMPTOM_DETAIL_BY_ID_ERROR:
      return {
        ...state,
        fetchSymptomDetailByIdInProgress: false,
        fetchSymptomDetailByIdError: true,
      };
    case FETCH_RELATED_TUTORIALS_REQUEST:
      return {
        ...state,
        fetchRelatedTutorialsInProgress: true,
        fetchRelatedTutorialsError: false,
      };
    case FETCH_RELATED_TUTORIALS_SUCCESS:
      return {
        ...state,
        relatedTutorials: payload,
        fetchRelatedTutorialsInProgress: false,
      };
    case FETCH_RELATED_TUTORIALS_ERROR:
      return {
        ...state,
        fetchRelatedTutorialsInProgress: false,
        fetchRelatedTutorialsError: true,
      };
    case FETCH_WELLNESS_PROGRAMS_REQUEST:
      return {
        ...state,
        fetchWellnessProgramsInProgress: true,
        fetchWellnessProgramsError: false,
      };
    case FETCH_WELLNESS_PROGRAMS_SUCCESS:
      return {
        ...state,
        wellnessPrograms: payload,
        fetchWellnessProgramsInProgress: false,
      };
    case FETCH_WELLNESS_PROGRAMS_ERROR:
      return {
        ...state,
        fetchWellnessProgramsInProgress: false,
        fetchWellnessProgramsError: true,
      };
    case FETCH_WELLNESS_PROGRAM_BY_ID_REQUEST:
      return {
        ...state,
        fetchWellnessProgramByIdInProgress: true,
        fetchWellnessProgramByIdError: false,
      };
    case FETCH_WELLNESS_PROGRAM_BY_ID_SUCCESS:
      return {
        ...state,
        wellnessProgram: payload,
        fetchWellnessProgramByIdInProgress: false,
      };
    case FETCH_WELLNESS_PROGRAM_BY_ID_ERROR:
      return {
        ...state,
        fetchWellnessProgramByIdInProgress: false,
        fetchWellnessProgramByIdError: true,
      };
    default:
      return state;
  }
}
// ================ Selectors ================ //
export const fetchTutorialDetailData = state => ({
  tutorialDetail: state.strapi.tutorialDetail,
  inProgress: state.strapi.fetchTutorialDetailInProgress,
  error: state.strapi.fetchTutorialDetailError,
});
export const fetchTutorialsData = state => {
  return { tutorials: state.strapi.tutorials, module: state.strapi.module };
};
export const fetchModulesData = state => {
  return state.strapi.module;
};
export const fetchTutorialsInProgress = state => {
  return state.strapi.fetchTutorialsInProgress;
};
export const fetchTutorialsErrors = state => {
  return state.strapi.fetchTutorialsError;
};
export const fetchEventsData = state => {
  return {
    events: state.strapi.events,
    inProgress: state.strapi.fetchEventsInProgress,
  };
};
export const fetchEventData = state => {
  return {
    event: state.strapi.event,
    inProgress: state.strapi.fetchEventInProgress,
    error: state.strapi.fetchEventError,
  };
};
export const fetchTopicsData = state => {
  return {
    writtenGuides: state.strapi.writtenGuides,
    fetchWrittenGuidesInProgress: state.strapi.fetchWrittenGuidesInProgress,
  };
};
export const fetchTopicsDetailsData = state => {
  return {
    topicDetails: state.strapi.topicDetails,
    fetchTopicDetailsInProgress: state.strapi.fetchTopicDetailsInProgress,
  };
};
export const fetchTutorialsSubcategoriesData = state => {
  return {
    symptoms: state.strapi.symptoms,
    tutorialsSubcategories: state.strapi.tutorialsSubcategories,
    fetchTutorialsSubcategoriesInProgress: state.strapi.fetchTutorialsSubcategoriesInProgress,
  };
};
export const fetchTheBasicsData = state => {
  return {
    topics: state.strapi.basicTopics,
    fetchTopicsInProgress: state.strapi.fetchTopicsInProgress,
  };
};
export const fetchSymptomBySlugData = state => {
  return {
    symptoms: state.strapi.symptoms,
    fetchSymptomInProgress: state.strapi.fetchSymptomInProgress,
  };
};
export const fetchSymptomCategoriesData = state => {
  return {
    symptomCategories: state.strapi.symptomCategories,
    fetchSymptomCategoriesInProgress: state.strapi.fetchSymptomCategoriesInProgress,
    fetchSymptomCategoriesError: state.strapi.fetchSymptomCategoriesError,
  };
};
export const fetchEventTagsData = state => {
  return {
    eventTags: state.strapi.eventTags,
    fetchEventTagsInProgress: state.strapi.fetchEventTagsInProgress,
    fetchEventTagsError: state.strapi.fetchEventTagsError,
  };
};
export const fetchWrittenGuideDetailData = state => ({
  writtenGuideDetail: state.strapi.writtenGuideDetail,
  inProgress: state.strapi.fetchWrittenGuideDetailInProgress,
  error: state.strapi.fetchWrittenGuideDetailError,
});
// Selector to get all popular data (topics and tutorials)
export const fetchPopularData = state => ({
  popularTopics: state.strapi.popularTopics,
  popularTutorials: state.strapi.popularTutorials,
  fetchPopularInProgress: state.strapi.fetchPopularInProgress,
  fetchPopularError: state.strapi.fetchPopularError,
});
export const fetchRelevantGuidesData = state => state.strapi.relevantGuides;
export const fetchRelatedTutorialsData = state => ({
  relatedTutorials: state.strapi.relatedTutorials,
  inProgress: state.strapi.fetchRelatedTutorialsInProgress,
  error: state.strapi.fetchRelatedTutorialsError,
});
export const fetchProductsData = state => ({
  products: state.strapi.products,
  inProgress: state.strapi.fetchProductsInProgress,
  error: state.strapi.fetchProductsError,
});
export const fetchProductBySlugData = state => ({
  product: state.strapi.product,
  inProgress: state.strapi.fetchProductBySlugInProgress,
  error: state.strapi.fetchProductBySlugError,
});
export const fetchProductStagesData = state => ({
  productStages: state.strapi.productStages,
  inProgress: state.strapi.fetchProductStagesInProgress,
  error: state.strapi.fetchProductStagesError,
});
export const fetchProductTypesData = state => ({
  productTypes: state.strapi.productTypes,
  inProgress: state.strapi.fetchProductTypesInProgress,
  error: state.strapi.fetchProductTypesError,
});
export const fetchSymptomDetailByIdData = state => ({
  symptomDetail: state.strapi.symptomDetail,
  inProgress: state.strapi.fetchSymptomDetailByIdInProgress,
  error: state.strapi.fetchSymptomDetailByIdError,
});
export const fetchWellnessProgramsData = state => ({
  wellnessPrograms: state.strapi.wellnessPrograms,
  inProgress: state.strapi.fetchWellnessProgramsInProgress,
  error: state.strapi.fetchWellnessProgramsError,
});
export const fetchWellnessProgramByIdData = state => {
  const apiProgram = state.strapi.wellnessProgram;
  const inProgress = state.strapi.fetchWellnessProgramByIdInProgress;
  const error = state.strapi.fetchWellnessProgramByIdError;
  const currentUser = state.user.currentUser;
  const userProgressAll = currentUser?.attributes?.profile?.publicData?.wellnessProgress || [];
  const progressEntry = userProgressAll.find(up => up.id === apiProgram?.id) || {
    status: PROGRAM_STATUS.NONE,
    tasks: [],
    selfCheck: null,
  };

  if (inProgress || error || !apiProgram) {
    return { wellnessProgram: null, inProgress, error };
  }

  const attributes = apiProgram.attributes;
  const tasks =
    attributes.tasks?.map(t => ({
      ...t,
      taskImage: null,
      relatedResource: t.videoURL
        ? { type: 'video', media: t.videoURL, title: null, content: '', duration: null }
        : t,
      options: [],
      durationMinutes: 5,
      completed: !!progressEntry.tasks.find(pt => pt.id === t.id)?.completed,
      score: progressEntry.tasks.find(pt => pt.id === t.id)?.score,
      answers: progressEntry.tasks.find(pt => pt.id === t.id)?.answers,
      currentIndex: progressEntry.tasks.find(pt => pt.id === t.id)?.currentIndex,
      openedAt: progressEntry.tasks.find(pt => pt.id === t.id)?.openedAt,
    })) || [];
  const selfCheck =
    attributes.selfCheck?.length > 0
      ? {
          id: `self-check-${apiProgram.id}`,
          name: attributes.selfCheck[0].title,
          questions:
            attributes.selfCheck[0]?.questions || getStaticWellnessSelfCheck(getDefaultLocale()),
          completed: !!progressEntry.selfCheck?.completed,
          answers: progressEntry.selfCheck?.answers || {},
          currentIndex: progressEntry.selfCheck?.currentIndex || 0,
          score: progressEntry.selfCheck?.score || null,
          scoringScale: attributes?.selfCheck[0]?.scoringScale || null,
        }
      : null;
  const wellnessProgram = {
    id: apiProgram.id,
    image: attributes.programImage?.data?.attributes?.url || staticCardImage,
    title: attributes.title,
    description: attributes.description,
    tasks,
    questions: selfCheck?.questions,
    selfCheck,
    status: progressEntry.status,
    localizations: attributes.localizations,
  };

  return { wellnessProgram, inProgress, error };
};
// ================ Action creators ================ //
export const fetchTutorialDetailRequest = () => ({ type: FETCH_TUTORIAL_DETAIL_REQUEST });
export const fetchTutorialDetailSuccess = payload => ({
  type: FETCH_TUTORIAL_DETAIL_SUCCESS,
  payload,
});
export const fetchTutorialDetailError = () => ({ type: FETCH_TUTORIAL_DETAIL_ERROR });
export const fetchProductsRequest = () => ({ type: FETCH_PRODUCTS_REQUEST });
export const fetchProductsSuccess = payload => ({ type: FETCH_PRODUCTS_SUCCESS, payload });
export const fetchProductsError = () => ({ type: FETCH_PRODUCTS_ERROR });
export const fetchProductStagesRequest = () => ({ type: FETCH_PRODUCT_STAGES_REQUEST });
export const fetchProductStagesSuccess = payload => ({
  type: FETCH_PRODUCT_STAGES_SUCCESS,
  payload,
});
export const fetchProductStagesError = () => ({ type: FETCH_PRODUCT_STAGES_ERROR });
export const fetchProductTypesRequest = () => ({ type: FETCH_PRODUCT_TYPES_REQUEST });
export const fetchProductTypesSuccess = payload => ({ type: FETCH_PRODUCT_TYPES_SUCCESS, payload });
export const fetchProductTypesError = () => ({ type: FETCH_PRODUCT_TYPES_ERROR });
export const fetchEventTagsRequest = () => ({
  type: FETCH_EVENT_TAGS_REQUEST,
});
export const fetchEventTagsSuccess = payload => ({
  type: FETCH_EVENT_TAGS_SUCCESS,
  payload,
});
export const fetchEventTagsError = () => ({
  type: FETCH_EVENT_TAGS_ERROR,
});
export const fetchSymptomBySlugRequest = () => ({
  type: FETCH_SYMPTOM_BY_SLUG_REQUEST,
});
export const fetchSymptomBySlugSuccess = payload => ({
  type: FETCH_SYMPTOM_BY_SLUG_SUCCESS,
  payload,
});
export const fetchSymptomBySlugError = () => ({
  type: FETCH_SYMPTOM_BY_SLUG_ERROR,
});
export const fetchPopularRequest = () => ({
  type: FETCH_POPULAR_REQUEST,
});
export const fetchPopularSuccess = payload => ({
  type: FETCH_POPULAR_SUCCESS,
  payload,
});
export const fetchPopularError = () => ({
  type: FETCH_POPULAR_ERROR,
});
export const fetchTheBasicsRequest = () => ({
  type: FETCH_THE_BASICS_REQUEST,
});
export const fetchTheBasicsSuccess = payload => ({
  type: FETCH_THE_BASICS_SUCCESS,
  payload,
});
export const fetchTheBasicsError = () => ({
  type: FETCH_THE_BASICS_ERROR,
});
export const fetchTutorialsRequest = () => ({
  type: FETCH_TUTORIALS_REQUEST,
});
export const fetchTutorialsSuccess = payload => ({
  type: FETCH_TUTORIALS_SUCCESS,
  payload,
});
export const fetchTutorialsError = () => ({
  type: FETCH_TUTORIALS_ERROR,
});
export const clearTutorials = () => ({
  type: CLEAR_TUTORIALS,
});
export const fetchEventsRequest = () => ({
  type: FETCH_EVENTS_REQUEST,
});
export const fetchEventsSuccess = payload => ({
  type: FETCH_EVENTS_SUCCESS,
  payload,
});
export const fetchEventRequest = () => ({
  type: FETCH_EVENT_REQUEST,
});
export const fetchEventSuccess = payload => ({
  type: FETCH_EVENT_SUCCESS,
  payload,
});
export const fetchEventError = () => ({
  type: FETCH_EVENT_ERROR,
});
export const fetchTopicsRequest = () => ({
  type: FETCH_TOPIC_REQUEST,
});
export const fetchTopicsSuccess = payload => ({
  type: FETCH_TOPIC_SUCCESS,
  payload,
});
export const fetchTopicsDetailsRequest = () => ({
  type: FETCH_TOPIC_DETAILS_REQUEST,
});
export const fetchTopicsDetailsSuccess = payload => ({
  type: FETCH_TOPIC_DETAILS_SUCCESS,
  payload,
});
export const fetchTutorialSubcategoriesRequest = () => ({
  type: FETCH_TUTORIALS_SUBCATEGORIES_REQUEST,
});
export const fetchTutorialSubcategoriesSuccess = payload => ({
  type: FETCH_TUTORIALS_SUBCATEGORIES_SUCCESS,
  payload,
});
export const fetchSymptomsSuccess = payload => ({
  type: FETCH_SYMPTOMS_SUCCESS,
  payload,
});
export const fetchSymptomCategoriesRequest = () => ({
  type: FETCH_SYMPTOM_CATEGORIES_REQUEST,
});
export const fetchSymptomCategoriesSuccess = payload => ({
  type: FETCH_SYMPTOM_CATEGORIES_SUCCESS,
  payload,
});
export const fetchSymptomCategoriesError = () => ({
  type: FETCH_SYMPTOM_CATEGORIES_ERROR,
});
export const fetchProductBySlugRequest = () => ({ type: FETCH_PRODUCT_BY_SLUG_REQUEST });
export const fetchProductBySlugSuccess = payload => ({
  type: FETCH_PRODUCT_BY_SLUG_SUCCESS,
  payload,
});
export const fetchProductBySlugError = () => ({ type: FETCH_PRODUCT_BY_SLUG_ERROR });
export const fetchProductByIdError = () => ({ type: FETCH_PRODUCT_BY_ID_ERROR });
export const fetchWrittenGuideByIdRequest = () => ({ type: FETCH_WRITTEN_GUIDE_BY_ID_REQUEST });
export const fetchWrittenGuideByIdSuccess = payload => ({
  type: FETCH_WRITTEN_GUIDE_BY_ID_SUCCESS,
  payload,
});
export const fetchWrittenGuideByIdError = () => ({ type: FETCH_WRITTEN_GUIDE_BY_ID_ERROR });
export const fetchRelevantGuidesRequest = () => ({ type: FETCH_RELEVANT_GUIDES_REQUEST });
export const fetchRelevantGuidesSuccess = payload => ({
  type: FETCH_RELEVANT_GUIDES_SUCCESS,
  payload,
});
export const fetchRelevantGuidesError = () => ({ type: FETCH_RELEVANT_GUIDES_ERROR });
export const fetchSymptomDetailByIdRequest = () => ({ type: FETCH_SYMPTOM_DETAIL_BY_ID_REQUEST });
export const fetchSymptomDetailByIdSuccess = payload => ({
  type: FETCH_SYMPTOM_DETAIL_BY_ID_SUCCESS,
  payload,
});
export const fetchSymptomDetailByIdError = () => ({ type: FETCH_SYMPTOM_DETAIL_BY_ID_ERROR });
export const fetchRelatedTutorialsRequest = () => ({ type: FETCH_RELATED_TUTORIALS_REQUEST });
export const fetchRelatedTutorialsSuccess = payload => ({
  type: FETCH_RELATED_TUTORIALS_SUCCESS,
  payload,
});
export const fetchRelatedTutorialsError = () => ({ type: FETCH_RELATED_TUTORIALS_ERROR });
export const fetchWellnessProgramsRequest = () => ({ type: FETCH_WELLNESS_PROGRAMS_REQUEST });
export const fetchWellnessProgramsSuccess = payload => ({
  type: FETCH_WELLNESS_PROGRAMS_SUCCESS,
  payload,
});
export const fetchWellnessProgramsError = () => ({ type: FETCH_WELLNESS_PROGRAMS_ERROR });
export const fetchWellnessProgramByIdRequest = () => ({
  type: FETCH_WELLNESS_PROGRAM_BY_ID_REQUEST,
});
export const fetchWellnessProgramByIdSuccess = payload => ({
  type: FETCH_WELLNESS_PROGRAM_BY_ID_SUCCESS,
  payload,
});
export const fetchWellnessProgramByIdError = () => ({ type: FETCH_WELLNESS_PROGRAM_BY_ID_ERROR });
// ================ Thunks ================ //
export const getTutorialVideo = params => async (dispatch, getState, sdk) => {
  dispatch(fetchTutorialDetailRequest());
  try {
    const tutorialsResponse = await getTutorialBySlug({ defaultLocale, ...params });
    const tutorial = Array.isArray(tutorialsResponse?.tutorials) && tutorialsResponse.tutorials[0];
    if (tutorial) {
      dispatch(fetchTutorialDetailSuccess(tutorial));
    } else {
      dispatch(fetchTutorialDetailError());
    }
    return tutorial;
  } catch (error) {
    console.error('Error fetching tutorial video:', error);
    dispatch(fetchTutorialDetailError());
  }
};
export const fetchVideoTutorials = params => async (dispatch, getState, sdk) => {
  dispatch(fetchTutorialsRequest());
  try {
    const tutorialsResponse = await fetchTutorials({ defaultLocale, ...params });
    dispatch(fetchTutorialsSuccess(tutorialsResponse));
    return tutorialsResponse;
  } catch (error) {
    dispatch(fetchTutorialsError());
  }
};
export const fetchEvents = params => async (dispatch, getState, sdk) => {
  dispatch(fetchEventsRequest());
  try {
    const { events = {} } = (await getEvents({ defaultLocale, ...params })) || {};
    dispatch(fetchEventsSuccess(events));
    return events;
  } catch (error) {}
};
export const fetchEventTags = params => async (dispatch, getState, sdk) => {
  dispatch(fetchEventTagsRequest());
  try {
    const { eventTags = [] } = (await getEventTags({ defaultLocale, ...params })) || {};
    dispatch(fetchEventTagsSuccess(eventTags));
    return eventTags;
  } catch (error) {
    console.error('Error while fetching event tags:', error);
    dispatch(fetchEventTagsError());
  }
};
export const fetchEvent = params => async (dispatch, getState, sdk) => {
  dispatch(fetchEventRequest());
  try {
    const { event = [] } = (await getEvent({ defaultLocale, ...params })) || {};
    dispatch(fetchEventSuccess(isArrayLength(event) && event[0]));
    return event;
  } catch (error) {
    dispatch(fetchEventError());
  }
};
export const fetchTopics = params => async (dispatch, getState, sdk) => {
  dispatch(fetchTopicsRequest());
  try {
    const { topics = [] } = (await getTopics({ defaultLocale, ...params })) || {};
    dispatch(fetchTopicsSuccess(topics));
    return topics;
  } catch (error) {}
};
export const fetchTopicDetails = params => async (dispatch, getState, sdk) => {
  dispatch(fetchTopicsDetailsRequest());
  try {
    const { topics = [] } = (await getTopicDetails({ defaultLocale, ...params })) || {};
    dispatch(fetchTopicsDetailsSuccess(topics));
    return topics;
  } catch (error) {}
};
export const fetchTheBasics = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(fetchTheBasicsRequest());
  try {
    const { topics = [] } = (await getTheBasics({ defaultLocale, ...params })) || {};
    dispatch(fetchTheBasicsSuccess(topics));
    return topics;
  } catch (error) {
    dispatch(fetchTheBasicsError());
  }
};
export const fetchTutorialSubcategories = params => async (dispatch, getState, sdk) => {
  dispatch(fetchTutorialSubcategoriesRequest());
  try {
    const [tutorialsResponse, symptomsResponse] = await Promise.all([
      getTutorialSubcategories({ defaultLocale, ...params }),
      getSymptoms({ defaultLocale, ...params }),
    ]);
    const tutorials = tutorialsResponse?.tutorials || [];
    const symptoms = symptomsResponse?.symptoms || [];
    dispatch(fetchTutorialSubcategoriesSuccess(tutorials));
    dispatch(fetchSymptomsSuccess(symptoms));
    return tutorials;
  } catch (error) {
    console.error('Error while fetching tutorials subcategories:', error);
    // dispatch(fetchTutorialSubcategoriesFailure(error));
    return [];
  }
};
export const fetchModulesCategories = params => async (dispatch, getState, sdk) => {
  dispatch(fetchTutorialSubcategoriesRequest());
  try {
    const tutorialsResponse = await getTutorialSubcategories({ defaultLocale, ...params });
    const tutorials = tutorialsResponse?.tutorials || [];
    dispatch(fetchTutorialSubcategoriesSuccess(tutorials));
    return tutorials;
  } catch (error) {
    console.error('Error while fetching tutorials subcategories:', error);
    // dispatch(fetchTutorialSubcategoriesFailure(error));
    return [];
  }
};
export const fetchSymptomBySlug = params => async (dispatch, getState, sdk) => {
  dispatch(fetchSymptomBySlugRequest());
  try {
    const { symptoms = [] } = (await getSymptoms({ defaultLocale, ...params })) || {};
    dispatch(fetchSymptomBySlugSuccess(symptoms));
    return symptoms;
  } catch (error) {
    console.error(error, 'Error while fetching symptom by slug');
    dispatch(fetchSymptomBySlugError());
  }
};
export const fetchSymptomCategories = params => async (dispatch, getState, sdk) => {
  dispatch(fetchSymptomCategoriesRequest());
  try {
    const { symptoms = [] } = (await getSymptomsCategories({ defaultLocale, ...params })) || {};
    dispatch(fetchSymptomCategoriesSuccess(symptoms));
    return symptoms;
  } catch (error) {
    console.error('Error while fetching symptom categories:', error);
    dispatch(fetchSymptomCategoriesError());
  }
};
export const fetchPopularContent = () => async (dispatch, getState, sdk) => {
  dispatch(fetchPopularRequest());
  try {
    const response = await getPopularItems({
      defaultLocale,
    });
    const popularTopics = response?.popularTopics || [];
    const popularTutorials = response?.popularTutorials || [];
    dispatch(fetchPopularSuccess({ topics: popularTopics, tutorials: popularTutorials }));
  } catch (error) {
    console.error('Error while fetching popular content:', error);
    dispatch(fetchPopularError());
  }
};
export const fetchProducts = params => async (dispatch, getState, sdk) => {
  dispatch(fetchProductsRequest());
  try {
    const { products = [] } = (await getProducts({ defaultLocale, ...params })) || {};
    dispatch(fetchProductsSuccess(products));
    return products;
  } catch (error) {
    console.error('Error while fetching products:', error);
    dispatch(fetchProductsError());
  }
};
export const fetchProductStages = params => async (dispatch, getState, sdk) => {
  dispatch(fetchProductStagesRequest());
  try {
    const { productStages = [] } = (await getProductStages({ defaultLocale, ...params })) || {};
    dispatch(fetchProductStagesSuccess(productStages));
    return productStages;
  } catch (error) {
    console.error('Error while fetching product stages:', error);
    dispatch(fetchProductStagesError());
  }
};
export const fetchProductTypes = params => async (dispatch, getState, sdk) => {
  dispatch(fetchProductTypesRequest());
  try {
    const { productTypes = [] } = (await getProductTypes({ defaultLocale, ...params })) || {};
    dispatch(fetchProductTypesSuccess(productTypes));
    return productTypes;
  } catch (error) {
    console.error('Error while fetching product types:', error);
    dispatch(fetchProductTypesError());
  }
};
export const getWrittenGuideById = params => async (dispatch, getState, sdk) => {
  dispatch(fetchWrittenGuideByIdRequest());
  try {
    const response = await getTopicDetailById({ defaultLocale, ...params });
    const guide = response?.guide?.data;
    if (guide) {
      dispatch(fetchWrittenGuideByIdSuccess(guide));
    } else {
      dispatch(fetchWrittenGuideByIdError());
    }
    return guide;
  } catch (error) {
    dispatch(fetchWrittenGuideByIdError());
  }
};
export const getRelevantGuides = params => async (dispatch, getState, sdk) => {
  dispatch(fetchRelevantGuidesRequest());
  try {
    const response = await fetchArticlesByTopic({ defaultLocale, ...params });
    dispatch(fetchRelevantGuidesSuccess(response.articles));
    return response.articles;
  } catch (error) {
    dispatch(fetchRelevantGuidesError());
    throw error;
  }
};
export const fetchSymptomDetailById = params => async (dispatch, getState, sdk) => {
  dispatch(fetchSymptomDetailByIdRequest());
  try {
    const response = await getSymptomDetailById({ defaultLocale, ...params });
    const guide = response?.guide?.data;
    if (guide) {
      dispatch(fetchSymptomDetailByIdSuccess(guide));
    } else {
      dispatch(fetchSymptomDetailByIdError());
    }
    return guide;
  } catch (error) {
    dispatch(fetchSymptomDetailByIdError());
  }
};
export const fetchRelatedTutorials = params => async (dispatch, getState, sdk) => {
  dispatch(fetchRelatedTutorialsRequest());
  try {
    const response = await getRelatedTutorials({ defaultLocale, ...params });
    dispatch(fetchRelatedTutorialsSuccess(response.tutorials));
    return response.tutorials;
  } catch (error) {
    dispatch(fetchRelatedTutorialsError());
    throw error;
  }
};

export const fetchProductBySlug = params => async (dispatch, getState, sdk) => {
  dispatch(fetchProductBySlugRequest());
  try {
    const response = await getProductBySlug({ defaultLocale, ...params });
    const product = Array.isArray(response?.products) && response.products[0];
    if (product) {
      dispatch(fetchProductBySlugSuccess(product));
    } else {
      dispatch(fetchProductBySlugError());
    }
    return product;
  } catch (error) {
    console.error('Error fetching product by slug:', error);
    dispatch(fetchProductBySlugError());
  }
};
export const fetchWellnessPrograms = body => async (dispatch, getState, sdk) => {
  dispatch(fetchWellnessProgramsRequest());
  try {
    const currentLocale = getStrapiLocale() || 'en';
    const response = await getWellnessPrograms({ defaultLocale: currentLocale, ...body });
    const { wellnessPrograms = [] } = response || {};
    dispatch(fetchWellnessProgramsSuccess(wellnessPrograms));
    return wellnessPrograms;
  } catch (error) {
    dispatch(fetchWellnessProgramsError());
  }
};
export const fetchWellnessProgramById = params => async (dispatch, getState, sdk) => {
  dispatch(fetchWellnessProgramByIdRequest());
  try {
    const currentLocale = getStrapiLocale() || 'en';
    const response = await getWellnessProgramById({
      defaultLocale: params?.defaultLocale || currentLocale,
      id: params.id,
    });
    const program = response.wellnessProgram || null;
    if (program) {
      dispatch(fetchWellnessProgramByIdSuccess(program));
    } else {
      dispatch(fetchWellnessProgramByIdError());
    }
    return program;
  } catch (error) {
    console.error('Error fetching wellness program by id:', error);
    dispatch(fetchWellnessProgramByIdError());
  }
};
